import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import { IconButton } from '../Button';
import { FaSun, FaMoon } from 'react-icons/fa';

interface ThemeToggleProps {
  className?: string;
}

/**
 * A small toggle button that switches between light and dark mode.
 * Uses sun icon for dark mode (click to go light) and moon icon for light mode.
 */
export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <IconButton
      icon={isDark ? FaSun({ 'aria-hidden': 'true' }) : FaMoon({ 'aria-hidden': 'true' })}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      className={className}
    />
  );
};
